export default __webpack_public_path__ + "7932cac97af2507357dd6351ee6e4004.svg";